export const SHOW_POPUP = '@popup/SHOW_POPUP';
export const HIDE_POPUP = '@popup/HIDE_POPUP';

export function showPopup(name, params) {
  return { type: SHOW_POPUP, name, params };
}

export function hidePopup(name) {
  return { type: HIDE_POPUP, name };
}

const initialState = {
  list: {},
};

export default function popupReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_POPUP: {
      return {
        ...state,
        list: {
          ...state.list,
          [action.name]: {
            ...state.list[action.name],
            ...action.params,
            isOpen: true,
          },
        },
      };
    }

    case HIDE_POPUP: {
      return {
        ...state,
        list: {
          ...state.list,
          [action.name]: {
            ...state.list[action.name],
            isOpen: false,
          },
        },
      };
    }
    default:
      return state;
  }
}
